"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareClassServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class ShareClassServiceLive {
    async getShareClasses(companyId) {
        try {
            const response = (await HttpProvider_1.httpProvider.get(`/company/${companyId}/share-classes`));
            return response.data;
        }
        catch (err) {
            return {
                status: false,
                message: err.message,
                payload: [],
            };
        }
    }
    async getShareholderHoldingForShareClass(companyId, shareholderId, shareClassId) {
        try {
            const response = (await HttpProvider_1.httpProvider.get(`/company/${companyId}/share-classes/${shareClassId}/shareholder/${shareholderId}`));
            return response.data;
        }
        catch (err) {
            return {
                status: false,
                message: err.message,
                payload: null,
            };
        }
    }
}
exports.ShareClassServiceLive = ShareClassServiceLive;
//# sourceMappingURL=ShareClassServiceLive.js.map